<template>
  <div v-loading="this.isLoading">
    <el-header height="300">
      <el-row :gutter="20" type="flex" align="middle" justify="center">
        <el-col :span="6" :offset="0">
          <el-button type="danger" v-if="currentData.LoopMachineState === `Activating`" @click="handleChangeState(false)">
            Activing - Click to hold
          </el-button>
          <el-button type="primary" v-if="currentData.LoopMachineState === `Holding`" @click="handleChangeState(true)">
            Holding - Click to Active
          </el-button>
        </el-col>
        <el-col :offset="0">
          <h1>THE NEXT EVENT WILL BE SET UP AUTOMATICALLY <span class="red-text">{{ this.nextSetUpCountDown }}</span></h1>
        </el-col>
        <el-col :span="10" :offset="0">
          <el-row>
            <el-button
                v-if="currentErrorMsg.length === 0"
                type="success"
                size="default"
                @click="handleApplyData"
            >Apply Data
            </el-button>
            <el-button
                v-if="currentErrorMsg.length > 0"
                type="danger"
                size="default"
                @click="doNothingFunction"
            >Apply Data
            </el-button>
          </el-row>
          <el-row>
           <ul>
              <li  v-for="msg in this.currentErrorMsg" :key="msg">
                {{ msg }}
              </li>
            </ul>
          </el-row>

        </el-col>
      </el-row>
    </el-header>

    <el-tabs type="border-card" tab-position="top" v-model="tabActive">
      <!-- DYNAMIC EVENT -->
      <el-tab-pane label="DYNAMIC EVENT" name="DYNAMIC EVENT">
        <el-main>
          <h1>DYNAMIC EVENT</h1>
          <el-form ref="form" :model="loopEventRaidBossForm" label-width="300px">
            <MyFormItem label="Time Start" tooltip="Thời gian bắt đầu của Event gần nhất tiếp theo (giây)">
              <el-date-picker
                v-model="dateInputTimeStart"
                type="datetime"
                value-format="timestamp"
                placeholder="Select date and time"
              >
              </el-date-picker>
            </MyFormItem>

            <MyFormItem label="Time Start Server" tooltip="Thời gian bắt đầu của Event gần nhất tiếp theo (giây)">
              <el-date-picker
                v-model="dateInputTimeStartServer"
                type="datetime"
                disabled
                value-format="timestamp"
                placeholder="Select date and time"
              >
              </el-date-picker>
            </MyFormItem>

            <MyFormItem label="Event Duration" tooltip="Thời gian kéo dài của event (giây)">
              <TimeInput :value="currentData.EventDuration" :on-change="handleOnEventDurationChange"/>
            </MyFormItem>

            <MyFormItem  label="Time Delay" tooltip="Thời gian chờ đến lúc lên Event tiếp theo (giây)">
              <TimeInput :value="currentData.TimeDelay" :on-change="handleOnTimeDelayChange"/>
            </MyFormItem>

            <MyFormItem label="Coming soon before" tooltip="Thời gian Coming Soon trước Time Start bao lâu (giây)">
              <TimeInput :value="currentData.ComingSoonBefore" :on-change="handleOnComingSoonBeforeChange"/>
            </MyFormItem>

            <MyFormItem label="Setup before" tooltip="Thời gian Setup trước Time Start bao lâu (giây)">
              <TimeInput :value="currentData.SetupBefore" :on-change="handleOnSetupBeforeChange"/>
            </MyFormItem>

            <MyFormItem label="Affect From Version" tooltip="event xuất hiện từ phiên bản nào trở lên">
              <el-input class="form-input" v-model="currentData.AffectFromVersion" placeholder="Example: 1.65.0" size="normal" clearable></el-input>
            </MyFormItem>

            <MyFormItem label="Affect To Version" tooltip="event xuất hiện từ phiên bản nào trở lên">
              <el-input class="form-input" v-model="currentData.AffectToVersion" placeholder="Example: 1.65.0" size="normal" clearable></el-input>
            </MyFormItem>

            <MyFormItem label="Current Index Config" tooltip="Index config sử dụng cho đợt event sau">
              <el-input-number v-model="currentData.CurrentIndexConfig" size="normal" label="label" :step="1" :controls="true" :min="0" :max="currentData.MaxIndexConfig - 1"/>
            </MyFormItem>

            <MyFormItem label="Max Index Config" tooltip="Số lượng config có trong bundle">
              <el-input-number v-model="currentData.MaxIndexConfig" size="normal" label="label" :step="1" :controls="true" :min="1"/>
            </MyFormItem>

            <MyFormItem label="EventName Format" tooltip="EventName ví dụ: RAID BOSS OPERATION {MM/DD}">
              <el-input class="form-input" v-model="currentData.EventNameFormat" size="normal"></el-input>
            </MyFormItem>

          </el-form>
          <step-button nextTab="LEADERBOARD" @onChangeTabTo="handleChangeTabTo"/>
        </el-main>
      </el-tab-pane>

      <!-- LEADERBOARD -->
      <el-tab-pane label="LEADERBOARD" name="LEADERBOARD">
        <el-main>
          <h1>LEADERBOARD</h1>

          <upload-title>Reward List</upload-title>
          <el-form ref="form" label-width="300px">
            <MyFormItem label="Reward Files" tooltip="Đẩy các file reward lên (mini_1, mini_2, total, ...)">
                <el-row :gutter="20" type="flex" justify="start">
                  <el-col :offset="0">
                    <el-upload
                      drag
                      action=""
                      multiple
                      :auto-upload="false"
                      :on-change="handleChangeRewardFileList"
                      :on-remove="handleRemoveRewardFileList"
                      :file-list="rewardFileList"
                      class="file-list-item">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                    </el-upload>
                  </el-col>
                  <el-col :offset="0">
                    <el-tooltip content="Tải file .mlb đang show bên dưới" placement="top-start" effect="dark">
                      <el-button size="default" @click="handleDownloadCurrentRewardData"><i class="el-icon-download"></i> Download current config </el-button>
                    </el-tooltip>
                  </el-col>
                </el-row>
            </MyFormItem>

            <el-collapse :accordion="false" v-if="currentData.RewardData.length > 0">
              <el-collapse-item title="View Imported Reward List">
                <el-table :data="currentData.RewardData" border>
                  <el-table-column
                    prop="rewardName"
                    label="Reward Name"
                    width="180">
                  </el-table-column>
                  <el-table-column label="Reward List">
                    <template slot-scope="scope">
                      <el-table :data="scope.row.rewards" border>
                        <el-table-column prop="id" label="ID" width="65"></el-table-column>
                        <el-table-column prop="title" label="Title" width="250"></el-table-column>
                        <el-table-column prop="rankMin" label="Rank Min" width="100"></el-table-column>
                        <el-table-column prop="rankMax" label="Rank Max" width="100"></el-table-column>
                        <el-table-column prop="requiredPoint" label="Required Point" width="125"></el-table-column>
                        <el-table-column label="Gifts">
                          <template slot-scope="scope">
                            <el-table :data="JSON.parse(scope.row.gifts)" border>
                              <el-table-column
                                prop="code"
                                label="Code">
                              </el-table-column>
                              <el-table-column
                                prop="value"
                                label="Value"
                                width="100">
                              </el-table-column>
                            </el-table>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </el-form>

          <upload-title >User segments</upload-title>
          <el-form ref="form" label-width="300px">
            <MyFormItem label="User Segments" tooltip="Đẩy file User Segment lên">
              <el-row :gutter="20" type="flex" justify="start">
                <el-col  :offset="0">
                  <el-upload
                    drag
                    action=""
                    :auto-upload="false"
                    :file-list="userSegmentFileList"
                    :on-change="handleChangeUserSegmentFileList"
                    :on-remove="handleRemoveUserSegmentFileList"
                    class="file-list-item">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                  </el-upload>
                </el-col>
                <el-col  :offset="0">
                  <el-tooltip content="Tải file .mlb đang show bên dưới" placement="top-start" effect="dark">
                    <el-button size="default" @click="handleDownloadCurrentUserSegmentData"><i class="el-icon-download"></i> Download curent config</el-button>
                  </el-tooltip>

                  <el-tooltip content="Các thông tin cần biết về User Segment" placement="top-start" effect="dark">
                    <el-button size="default" @click="isDialogUserSegmentInfoVisible = true"><i class="el-icon-info"></i>Information</el-button>
                  </el-tooltip>
                  <el-dialog title="User Segment Information" :visible.sync="isDialogUserSegmentInfoVisible">
                    <h2>User Segment Types</h2>
                    <el-table :data="userSegmentInfo.types" border>
                      <el-table-column property="key" label="key"></el-table-column>
                      <el-table-column property="info" label="info"></el-table-column>
                    </el-table>
                  </el-dialog>
                </el-col>
              </el-row>
            </MyFormItem>

            <el-collapse :accordion="false" v-if="currentData.GrandBossData.length > 0">
              <el-collapse-item title="View Imported Data">
                <el-table :data="currentData.GrandBossData" border>
                  <el-table-column
                    prop="name"
                    label="Name"
                    width="400">
                  </el-table-column>
                  <el-table-column
                    prop="count"
                    label="Count">
                  </el-table-column>
                  <el-table-column
                    prop="size"
                    label="Size">
                  </el-table-column>
                  <el-table-column
                    prop="payment_size"
                    label="Payment Size">
                  </el-table-column>
                  <el-table-column
                    prop="none_payment_limit_size_1"
                    label="Non Payment">
                  </el-table-column>
                  <el-table-column
                    prop="rewardName"
                    label="Reward">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </el-form>

        </el-main>
        <step-button previousTab="DYNAMIC EVENT" nextTab="BOSS INFORMATION" @onChangeTabTo="handleChangeTabTo"/>
      </el-tab-pane>

      <!-- BOSS INFORMATION -->
      <el-tab-pane label="BOSS INFORMATION" name="BOSS INFORMATION">
        <el-main>
          <upload-title>Config Raidboss</upload-title>
          <el-form label-width="300px">
            <MyFormItem label="Config Raidboss File" tooltip="Đẩy file ConfigRaidBoss.mlb lên">
              <el-row :gutter="20" type="flex" justify="start">
                <el-col  :offset="0">
                  <el-upload
                    drag
                    action=""
                    multiple
                    :auto-upload="false"
                    :file-list="configRaidBossFileList"
                    :on-change="handleChangeBossInfoFileList"
                    :on-remove="handleRemoveBossInfoFileList"
                    class="file-list-item">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                  </el-upload>
                </el-col>
                <el-col  :offset="0">
                  <el-tooltip content="Tải file .mlb đang show bên dưới" placement="top-start" effect="dark">
                    <el-button size="default" @click="handleDownloadCurrentRaidBossConfig"><i class="el-icon-download"></i> Download current config</el-button>
                  </el-tooltip>
                </el-col>
              </el-row>
            </MyFormItem>

            <el-collapse :accordion="false" v-if="currentData.ConfigRaidBossData.length > 0">
              <el-collapse-item title="View Imported Data">
                <el-table :data="currentData.ConfigRaidBossData" border>
                  <el-table-column
                      prop="ID"
                      label="ID"
                      width="100">
                  </el-table-column>
                  <el-table-column
                      prop="Segment"
                      label="Segment">
                  </el-table-column>
                  <el-table-column
                      prop="Name"
                      label="Name">
                  </el-table-column>
                  <el-table-column
                      prop="Tier"
                      label="Tier">
                  </el-table-column>
                  <el-table-column
                      prop="MainHP"
                      label="MainHP">
                  </el-table-column>
                </el-table>
              </el-collapse-item>
            </el-collapse>
          </el-form>

          <h2>Boss Settings</h2>
          <el-form label-width="300px">
            <MyFormItem label="Boss Caption" tooltip="Boss Caption">
              <el-input class="form-input" v-model="currentData.BossConfig.BossCaption" placeholder="Example: ${RaidBoss<tier>}" size="normal" clearable></el-input>
            </MyFormItem>

            <MyFormItem label="Count" tooltip="Số lượng boss trong 1 event">
              <el-input-number v-model="currentData.BossConfig.Count" size="normal" label="Boss Count" :min="1" :max="3"
                :step="1" :controls="true" controls-position="both" disabled>
              </el-input-number>
              <span>&nbsp; boss{{currentData.BossConfig.Count > 1 ? 'es' : ''}}</span>
            </MyFormItem>

            <MyFormItem label="Active Time" tooltip="Khoảng thời gian giữa 2 con boss - session 1 con boss (giây)">
              <TimeInput :value="currentData.BossConfig.ActiveTime" :on-change="handleOnBossActiveTimeChange"/>
            </MyFormItem>

            <MyFormItem label="Living Time" tooltip="Thời gian con boss hoạt động trong session trên (giây)">
              <TimeInput :value="currentData.BossConfig.LivingTime" :on-change="handleOnBossLivingTimeChange"/>
            </MyFormItem>

            <MyFormItem label="Waiting Time" tooltip="Thời gian chờ khi con boss session trước hết hoạt động đến khi bắt đầu session tiếp theo (giây)">
              <el-input class="form-input" v-model="bossWaitingTime" size="normal" disabled/>
              <SpanTime :numberOfSeconds="bossWaitingTime"/>
            </MyFormItem>
          </el-form>

          <el-collapse :accordion="false" v-if="littleBossData.length > 0">
            <el-collapse-item title="View Imported Reward List">
              <el-table :data="littleBossData" border>
                <el-table-column
                    prop="name"
                    label="Name"
                    width="200">
                </el-table-column>
                <el-table-column label="Info">
                  <template slot-scope="scope">
                    <el-table :data="scope.row.info" border>
                      <el-table-column prop="tag" label="tag"></el-table-column>
                      <el-table-column prop="bossCaption" label="bossCaption"></el-table-column>
                      <el-table-column prop="maxHP" label="maxHP"></el-table-column>
                      <el-table-column prop="level" label="level"></el-table-column>
                      <el-table-column prop="bossID" label="bossID"></el-table-column>
                      <el-table-column prop="rewardName" label="rewardName"></el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </el-main>

        <step-button previousTab="LEADERBOARD" nextTab="CLAN" @onChangeTabTo="handleChangeTabTo"/>
      </el-tab-pane>

      <!-- CLAN -->
      <el-tab-pane label="CLAN" name="CLAN">
        <upload-title>Clan Reward Config</upload-title>
        <el-form label-width="300px">
          <MyFormItem label="Clan Reward File" tooltip="Đẩy file Clan Reward lên">
            <el-row :gutter="20" type="flex" justify="start">
              <el-col  :offset="0">
                <el-upload
                  drag
                  action=""
                  :file-list="clanRewardFileList"
                  :auto-upload="false"
                  ref=""
                  :on-change="handleChangeClanRewardFileList"
                  :on-remove="handleRemoveClanRewardFileList"
                  class="file-list-item">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                </el-upload>
              </el-col>
              <el-col  :offset="0">
                <el-tooltip content="Tải file .mlb đang show bên dưới" placement="top-start" effect="dark">
                  <el-button size="default" @click="handleDownloadCurrentClanRewardFile"><i class="el-icon-download"></i> Download current config</el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </MyFormItem>

          <el-collapse class="space-to-bottom" :accordion="false" v-if="currentData.ClanRewardData.length > 0">
            <el-collapse-item title="View Imported Data">
              <el-table :data="currentData.ClanRewardData" border>
                <el-table-column
                    prop="id"
                    label="Index"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    label="Title">
                </el-table-column>
                <el-table-column
                    prop="rankMin"
                    label="RankMin">
                </el-table-column>
                <el-table-column
                    prop="rankMax"
                    label="RankMax">
                </el-table-column>
                <el-table-column
                    prop="requiredScore"
                    label="RequireScore">
                </el-table-column>
                <el-table-column
                    prop="rewards"
                    label="Rewards">
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </el-form>

        <upload-title>Clan Segment Config</upload-title>
        <el-form label-width="300px">
          <MyFormItem label="Clan Segment File" tooltip="Đẩy file LeaderBoardClanSegmentConfig.mlb lên">
            <el-row :gutter="20" type="flex" justify="start">
              <el-col  :offset="0">
                <el-upload
                  drag
                  action=""
                  :file-list="clanSegmentFileList"
                  :auto-upload="false"
                  ref=""
                  :on-change="handleChangeClanSegmentFileList"
                  :on-remove="handleRemoveClanSegmentFileList"
                  class="file-list-item">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                </el-upload>
              </el-col>
              <el-col  :offset="0">
                <el-tooltip content="Tải file .mlb đang show bên dưới" placement="top-start" effect="dark">
                  <el-button size="default" @click="handleDownloadCurrentClanSegmentFile"><i class="el-icon-download"></i> Download current config</el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </MyFormItem>

          <el-collapse class="space-to-bottom" :accordion="false" v-if="this.currentData.ClanSegmentData.length > 0">
            <el-collapse-item title="View Imported Data">
              <el-table :data="this.currentData.ClanSegmentData" border>
                <el-table-column
                    prop="name"
                    label="GroupName">
                </el-table-column>
                <el-table-column
                    prop="total"
                    label="TotalLDB">
                </el-table-column>
                <el-table-column
                    prop="size"
                    label="TotalClan">
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </el-form>

        <step-button previousTab="BOSS INFORMATION" @onChangeTabTo="handleChangeTabTo"/>


      </el-tab-pane>

      <!-- Log -->
    </el-tabs>
  </div>
</template>
<script>
import moment from "moment";

import './index.scss'

import SpanTime from './../component/spanTime.vue'
import StepButton from './../component/stepButton.vue'
import UploadTitle from './../component/uploadTitle.vue'
import TableForm from '@/components/TableForm/index.vue'
import MyFormItem from '@/views/loop-machine/component/myFormItem.vue'
import TimeInput from './../component/timeInput.vue'
import { getOSToken } from '@/utils/auth'
import { MessageBox, Message } from "element-ui";

import changeObjectKeys from '@/helpers/changeObjectKeys'
import downloadFile from '@/helpers/downloadFile'
import generateMLBFileContent from '@/helpers/generateMLBFileContent'
import parseMLBfile from '@/helpers/parseMLBfile'
import readFile from '@/helpers/readFile'

import request from "@/utils/request-service-admin";

export default {
  data() {
    return {
      // Common
      loopEventRaidBossForm: {},
      tabActive: 'DYNAMIC EVENT',
      isLoading: true,

      //server data
      loopRaidBossData: {
        TimeStart: 0,
        EventDuration: 0,
        TimeDelay: 0,
        SetupBefore: 0,
        ComingSoonBefore: 0,
        AffectFromVersion: "",
        AffectToVersion: "",
        CurrentIndexConfig: 0,
        MaxIndexConfig: 2,
        RewardData: [],
        GrandBossData: [],
        ClanRewardData: [],
        ClanSegmentData: [],
        ConfigRaidBossData: [],
        BossConfig: {
          ActiveTime: 0,
          LivingTime: 0,
          BossCaption: "${RaidBoss<tier>}",
          Count: 3,

        },
        EventNameFormat: "RAID BOSS EVENT {MM/DD}",
        LoopMachineState: "Holding",
      },

      countDownNextSetUp: 0,

      //dynamic event
      dateInputTimeStartServer: 0,

      // Leaderboard
      isDialogUserSegmentInfoVisible: false,

      userSegmentInfo: {
        types: [
          {
            key: 'us_region_lowerequal_4',
            info: 'all users in the tier1 countries: US, GB, FR, DE, IT, AU, CA, KR, JP, TW, HK'
          },
          {
            key: 'us_region_greater_4',
            info: 'all users in the tier1 countries: US, GB, FR, DE, IT, AU, CA, KR, JP, TW, HK'
          },
          {
            key: 'tier3_region_lowerequal_4',
            info: 'all users in the tier3 countries: IN, PH, ID'
          },
          {
            key: 'tier3_region_greater_4',
            info: 'all users in the tier3 countries: IN, PH, ID'
          },
          {
            key: 'others_region_lowerequal_4',
            info: 'other users'
          },
          {
            key: 'others_region_greater_4',
            info: 'other users'
          },
          {
            key: 'cheaters',
            info: 'Cheaters will be moved to this leaderboard'
          },
          {
            key: 'testers',
            info: 'For QC, Dev, ... to test event'
          },
        ]
      },

      // Boss info
      debounceTimerUploadBossInfoFileList: {},
    }
  },
  methods: {
    // Common
    handleChangeTabTo(tabName) {
      this.tabActive = tabName
    },
    doNothingFunction(){
    },
    IsIOS() {
      let OS = getOSToken();
      return OS && OS.toLowerCase() === 'ios';
    },
    updateCountDownTime(){
      this.countDownNextSetUp = (this.loopRaidBossData.TimeStart - this.loopRaidBossData.SetupBefore) - moment().unix();
    },
    parseDataToView() {
      this.dateInputTimeStartServer = this.currentData.TimeStart * 1000;
      this.updateCountDownTime();
    },

    async handleChangeState(isActive) {
      this.isLoading = true;

      try {
        let response = await request({
          url: `/admintool/loop-machine/update_state/Raidboss`,
          method: `post`,
          data: {isActive: isActive},
        });

        await this.getDataFromServer();

        Message({
          message: "Apply data success",
          type: "success",
          duration: 5 * 1000,
        });

        this.isLoading = false;
      }catch (ex) {
        Message({
          message: `Error ${ex}`,
          type: "error",
          duration: 5 * 1000,
        });
        this.isLoading = false;
      }


    },

    async getDataFromServer() {
      let data = await request({
        url: `/admintool/loop-machine/data/Raidboss`,
        method: `get`
      });

      this.currentData = data;
      this.parseDataToView();
    },
    async handleApplyData() {
      this.isLoading = true;

      try {
        let response = await request({
          url: `/admintool/loop-machine/update_data/Raidboss`,
          method: `post`,
          data: this.loopRaidBossData,
        });

        await this.getDataFromServer();

        Message({
          message: "Apply data success",
          type: "success",
          duration: 5 * 1000,
        });

        this.isLoading = false;
      } catch (ex) {
        Message({
          message: `Error ${ex}`,
          type: "error",
          duration: 5 * 1000,
        });
        this.isLoading = false;
      }
    },

    AwaitDelay(ms){
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      })
    },

    async autoCountDown() {
      let breakFunction = false;
      while (!breakFunction) {
        if (this.countDownNextSetUp > 0) {
          this.countDownNextSetUp -= 1;
        }

        await this.AwaitDelay(1000);
      }
    },

    // Dynamic
    handleOnEventDurationChange(value){
      this.currentData.EventDuration = value;
    },
    handleOnTimeDelayChange(value){
      this.currentData.TimeDelay = value;
    },
    handleOnComingSoonBeforeChange(value){
      this.currentData.ComingSoonBefore = value;
    },
    handleOnSetupBeforeChange(value){
      this.currentData.SetupBefore = value;
      this.updateCountDownTime();
    },

    // Leaderboard
    generalMlbContentOfReward(listData) {
      let dataList = [];
      for (let j = 0; j < listData.length; j++) {
        let data = listData[j];
        let tempString = `${data.id}\t${data.title}\t${data.rankMin}\t${data.rankMax}\t${data.requiredPoint}\t${data.gifts}`;
        dataList.push(tempString);
      }

      return generateMLBFileContent(`LeaderBoardGiftsConfig`,
          ["index", "Title", "RankMin", "RankMax", "CoinRequire", "Gifts"],
          ["int", "string", "int", "int", "int", "string"],
          dataList);
    },

    generalMlbContentOfUserSegment(listData) {
      let dataList = [];

      for (let j = 0; j < listData.length; j++) {
        let data = listData[j];
        let tempString = `${data.name}\t${data.count}\t${data.payment_size}\t${data.none_payment_limit_size_1}\t${data.size}\t${data.rewardName}`;
        dataList.push(tempString);
      }

      return generateMLBFileContent(`LeaderBoardSegmentConfig`,
          ['Name', 'Count', 'PaymentSize', 'NonPayment', 'TotalSize', 'Rewards'],
          ['string', 'int', 'int', 'int', 'int', 'string'],
          dataList);
    },

    generateMLBFileContentOfRaidBossConfig(listData) {
      let dataList = [];

      for (let j = 0; j < listData.length; j++) {
        let data = listData[j];
        let tempString = `${data.ID}\t${data.Segment}\t${data.Name}\t${data.Tier}\t${data.MainHP}`;
        dataList.push(tempString);
      }

      return generateMLBFileContent(`ConfigRaidBoss`,
          ['ID', 'Segment', 'Name', 'Tier', 'MainHP'],
          ['int', 'string', 'string', 'string', 'int'],
          dataList);
    },

    generateMLBFileContentOfClanReward(listData) {
      let dataList = [];

      for (let j = 0; j < listData.length; j++) {
        let data = listData[j];
        let tempString = `${data.id}\t${data.title}\t${data.rankMin}\t${data.rankMax}\t${data.requiredScore}\t${data.rewards}`;
        dataList.push(tempString);
      }

      return generateMLBFileContent(`LeaderBoardRewardsConfig`,
          ['index', 'Title', 'RankMin', 'RankMax', 'RequiredScore', 'Rewards'],
          ['int', 'string', 'int', 'int', 'int', 'string'],
          dataList);
    },

    generateMLBFileContentOfClanSegment(listData) {
      let dataList = [];

      for (let j = 0; j < listData.length; j++) {
        let data = listData[j];
        let tempString = `${data.name}\t${data.total}\t${data.size}`;
        dataList.push(tempString);
      }

      return generateMLBFileContent(`LeaderBoardClanSegmentConfig`,
          ['GroupName', 'TotalLDB', 'TotalClan'],
          ['string', 'int', 'int'],
          dataList);
    },

    async onRewardFileListChange(fileList) {
      this.isLoading = true;
      this.loopRaidBossData.RewardData = [];

      const keyMap = {
        "index": "id",
        "Title": "title",
        "RankMin": "rankMin",
        "RankMax": "rankMax",
        "CoinRequire": "requiredPoint",
        "Gifts": "gifts"
      }

      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].raw) {
          fileList[i].rawText = await readFile(fileList[i].raw);
        }

        let rewardGiftsUnMapped = parseMLBfile(fileList[i].rawText);
        let rewardGifts = rewardGiftsUnMapped.map(unMappedReward => changeObjectKeys(unMappedReward, keyMap))
        this.loopRaidBossData.RewardData.push(
            {
              rewardName: fileList[i].name.split('.mlb')[0],
              rewards: rewardGifts,
            }
        );
      }

      this.isLoading = false;
    },

    async handleChangeRewardFileList(file, fileList) {
      await this.onRewardFileListChange(fileList);
    },
    async handleRemoveRewardFileList(file, fileList) {
      await this.onRewardFileListChange(fileList);
    },

    handleDownloadCurrentRewardData() {
      for (let i = 0; i < this.loopRaidBossData.RewardData.length; i++) {
        downloadFile(`${this.loopRaidBossData.RewardData[i].rewardName}.mlb`,
            this.generalMlbContentOfReward(this.loopRaidBossData.RewardData[i].rewards));
      }
    },

    async onUserSegmentFileListChange(fileList) {
      this.isLoading = true;
      this.loopRaidBossData.GrandBossData = [];

      const keyMap = {
        "Name": "name",
        "Count": "count",
        "TotalSize": "size",
        "PaymentSize": "payment_size",
        "NonPayment": "none_payment_limit_size_1",
        "Rewards": "rewardName"
      }

      for (let i = 0; i < fileList.length; i++) {
        //not multi file
        if (i >= 1) {
          break
        }

        if (fileList[i].raw) {
          fileList[i].rawText = await readFile(fileList[i].raw);
        }

        const unMappedUserSegments = parseMLBfile(fileList[i].rawText);
        const userSegments = unMappedUserSegments.map(unMappedUserSegment => changeObjectKeys(unMappedUserSegment, keyMap))

        //console.log(`unMappedUserSegments = ${JSON.stringify(userSegments, null, 4)}`);
        this.loopRaidBossData.GrandBossData = userSegments;
      }

      //console.log(`GrandBossData length = ${this.loopRaidBossData.GrandBossData.length}`);

      this.isLoading = false;
    },
    async handleChangeUserSegmentFileList(file, fileList) {
      await this.onUserSegmentFileListChange(fileList);
    },
    async handleRemoveUserSegmentFileList(file, fileList) {
      await this.onUserSegmentFileListChange(fileList);
    },
    handleDownloadCurrentUserSegmentData() {
      if (this.loopRaidBossData.GrandBossData.length <= 0) {
        return;
      }

      downloadFile(`LeaderBoardSegmentConfig.mlb`,
          this.generalMlbContentOfUserSegment(this.loopRaidBossData.GrandBossData));
    },

    // Boss info
    async onBossInfoFileListChange(fileList) {
      this.isLoading = true;
      this.loopRaidBossData.ConfigRaidBossData = [];

      for (let i = 0; i < fileList.length; i++) {
        //not multi file
        if (i >= 1) {
          break
        }

        if (fileList[i].raw) {
          fileList[i].rawText = await readFile(fileList[i].raw);
        }

        let bossInfoTemp = parseMLBfile(fileList[i].rawText);
        let bossInfo = [];
        for (let j = 0; j < bossInfoTemp.length; j++) {
          let data = bossInfoTemp[j];
          let dataAdd = {
            ID: data.ID,
            Segment: data.Segment,
            Name: data.Name,
            Tier: data.Tier,
            MainHP: data.MainHP,
          };

          bossInfo.push(dataAdd);
        }

        this.loopRaidBossData.ConfigRaidBossData = bossInfo;
      }

      this.isLoading = false;
    },
    async handleChangeBossInfoFileList(file, fileList) {
      await this.onBossInfoFileListChange(fileList);
    },
    async handleRemoveBossInfoFileList(file, fileList) {
      await this.onBossInfoFileListChange(fileList);
    },
    handleDownloadCurrentRaidBossConfig() {
      if (this.loopRaidBossData.ConfigRaidBossData.length <= 0) {
        return;
      }

      downloadFile('ConfigRaidBoss.mlb',
          this.generateMLBFileContentOfRaidBossConfig(this.loopRaidBossData.ConfigRaidBossData));
    },

    handleOnBossActiveTimeChange(value){
      this.loopRaidBossData.BossConfig.ActiveTime = value;
    },
    handleOnBossLivingTimeChange(value){
      this.loopRaidBossData.BossConfig.LivingTime = value;
    },

    // Clan
    async onClanRewardFileListChange(fileList) {
      this.isLoading = true;
      this.loopRaidBossData.ClanRewardData = [];

      for (let i = 0; i < fileList.length; i++) {
        //not multi file
        if (i >= 1) {
          break
        }

        if (fileList[i].raw) {
          fileList[i].rawText = await readFile(fileList[i].raw);
        }

        let clanInfoTemp = parseMLBfile(fileList[i].rawText);
        let clanInfo = [];
        for (let j = 0; j < clanInfoTemp.length; j++) {
          let data = clanInfoTemp[j];
          clanInfo.push({
            id: data.index,
            title: data.Title,
            rankMin: data.RankMin,
            rankMax: data.RankMax,
            requiredScore: data.RequiredScore,
            rewards: data.Rewards,
          });
        }

        this.loopRaidBossData.ClanRewardData = clanInfo;
      }

      this.isLoading = false;
    },
    async handleChangeClanRewardFileList(file, fileList) {
      await this.onClanRewardFileListChange(fileList);
    },
    async handleRemoveClanRewardFileList(file, fileList) {
      await this.onClanRewardFileListChange(fileList);
    },
    handleDownloadCurrentClanRewardFile() {
      if (this.loopRaidBossData.ClanRewardData.length <= 0) {
        return;
      }

      downloadFile('LeaderBoardGiftsConfigClan_Total.mlb',
          this.generateMLBFileContentOfClanReward(this.loopRaidBossData.ClanRewardData));
    },
    helpParseRewardArray(rewardString) {
      return JSON.parse(rewardString.replace(/'/g, '"'));
    },
    async onClanSegmentFileListChange(fileList) {
      this.isLoading = true;
      this.loopRaidBossData.ClanSegmentData = [];

      for (let i = 0; i < fileList.length; i++) {
        //not multi file
        if (i >= 1) {
          break
        }

        if (fileList[i].raw) {
          fileList[i].rawText = await readFile(fileList[i].raw);
        }

        let clanSegmentTemp = parseMLBfile(fileList[i].rawText);
        let clanSegment = [];
        for (let j = 0; j < clanSegmentTemp.length; j++) {
          let data = clanSegmentTemp[j];
          clanSegment.push({
            name: data.GroupName,
            total: data.TotalLDB,
            size: data.TotalClan,
          });

        }

        this.loopRaidBossData.ClanSegmentData = clanSegment;
      }

      this.isLoading = false;
    },
    async handleChangeClanSegmentFileList(file, fileList) {
      await this.onClanSegmentFileListChange(fileList);
    },
    async handleRemoveClanSegmentFileList(file, fileList) {
      await this.onClanSegmentFileListChange(fileList);
    },
    handleDownloadCurrentClanSegmentFile() {
      if (this.loopRaidBossData.ClanSegmentData.length <= 0) {
        return;
      }

      downloadFile('LeaderBoardClanSegmentConfig.mlb',
          this.generateMLBFileContentOfClanSegment(this.loopRaidBossData.ClanSegmentData));
    },


  },

  async beforeMount() {
    await this.getDataFromServer();

    this.isLoading = false;
  },
  components: {
    UploadTitle,
    SpanTime,
    StepButton,
    //TableForm,
    MyFormItem,
    TimeInput,
  },
  computed: {
    currentData: {
      get: function() {
        return this.loopRaidBossData;
      },
      set: function (value) {
        this.loopRaidBossData = value;
      }
    },

    nextSetUpCountDown: {
      get: function() {
        let remainSecond = this.countDownNextSetUp;
        let totalDay = Math.floor(remainSecond / 86400);

        remainSecond = remainSecond - totalDay * 86400;
        let totalHour = Math.floor(remainSecond / 3600);

        remainSecond = remainSecond - totalHour * 3600;
        let totalMinute = Math.floor(remainSecond / 60);

        remainSecond = remainSecond - totalMinute * 60;

        let ret = "";
        if (totalDay > 0) {
          ret += `${totalDay} day`;
        }

        ret += ` ${String(totalHour).padStart(2, '0')}`
        ret += `:${String(totalMinute).padStart(2, '0')}`
        ret += `:${String(remainSecond).padStart(2, '0')}`

        return ret;
      },
    },

    bossWaitingTime() {
      return this.loopRaidBossData.BossConfig.ActiveTime - this.loopRaidBossData.BossConfig.LivingTime;
    },

    //Dynamic
    dateInputTimeStart: {
      get: function() {
        return this.currentData.TimeStart * 1000;
      },
      set: function(value) {
        this.currentData.TimeStart = value / 1000;
        this.updateCountDownTime();
      }
    },
    //LeaderBoard
    rewardFileList:{
      get: function () {
        let ret = [];
        for (let i = 0; i < this.loopRaidBossData.RewardData.length; i++) {
          ret.push(
              {
                name: `${this.loopRaidBossData.RewardData[i].rewardName}.mlb`,
                rawText: this.generalMlbContentOfReward(this.loopRaidBossData.RewardData[i].rewards),
              });
        }

        return ret;
      }
    },

    userSegmentFileList:{
      get: function () {
        let ret = [];

        if (this.loopRaidBossData.GrandBossData.length > 0) {
          ret.push(
              {
                name: `LeaderBoardSegmentConfig.mlb`,
                rawText: this.generalMlbContentOfUserSegment(this.loopRaidBossData.GrandBossData),
              });
        }

        return ret;
      }
    },

    //boss information
    configRaidBossFileList: {
      get: function() {
        let ret = [];

        if (this.loopRaidBossData.ConfigRaidBossData.length > 0) {
          ret.push(
              {
                name: `ConfigRaidBoss.mlb`,
                rawText: this.generateMLBFileContentOfRaidBossConfig(this.loopRaidBossData.ConfigRaidBossData),
              });
        }

        return ret;
      }
    },

    littleBossData: {
      get: function () {
        let retData = [];
        if (this.loopRaidBossData.GrandBossData.length === 0) {
          return retData;
        }

        if (this.loopRaidBossData.ConfigRaidBossData.length === 0) {
          return retData;
        }

        let dictRaidBossConfig = {};
        for (let i = 0; i < this.loopRaidBossData.ConfigRaidBossData.length; i++) {
          let bossConfig = this.loopRaidBossData.ConfigRaidBossData[i];
          dictRaidBossConfig[`${bossConfig.Segment}-${bossConfig.Tier}`] = bossConfig;
        }

        let prefix = "_android";
        if (this.IsIOS()){
          prefix = "_ios"
        }

        for (let i = 0; i < this.loopRaidBossData.BossConfig.Count; i++) {
          let infos = [];
          let bossCation = `${this.loopRaidBossData.BossConfig.BossCaption.replace('<tier>', (i + 1).toString().padStart(2, '0'))}`;

          for (let j = 0; j < this.loopRaidBossData.GrandBossData.length; j++) {
            let bossData = this.loopRaidBossData.GrandBossData[j];
            let bossConfigDictName = `${prefix}_${bossData.name}-${i + 1}`;
            let refBossConfig = dictRaidBossConfig[bossConfigDictName];
            let info = {
              tag: bossData.name,
              bossCaption: bossCation,
              maxHP: refBossConfig.MainHP,
              level: i + 1,
              bossID: refBossConfig.ID,
              rewardName: `mini_${i + 1}`,
            };

            infos.push(info);
          }

          let configData = {
            name: `raidboss_littleboss${i + 1}`,
            info: infos,
          };

          retData.push(configData);
        }

        return retData;
      }
    },

    //clan
    clanRewardFileList: {
      get: function() {
        let ret = [];

        if (this.loopRaidBossData.ClanRewardData.length > 0) {
          ret.push(
              {
                name: `LeaderBoardGiftsConfigClan_Total.mlb`,
                rawText: this.generateMLBFileContentOfClanReward(this.loopRaidBossData.ClanRewardData),
              });
        }

        return ret;
      }
    },

    clanSegmentFileList: {
      get: function() {
        let ret = [];

        if (this.loopRaidBossData.ClanSegmentData.length > 0) {
          ret.push(
              {
                name: `LeaderBoardClanSegmentConfig.mlb`,
                rawText: this.generateMLBFileContentOfClanSegment(this.loopRaidBossData.ClanSegmentData),
              });
        }

        return ret;
      }
    },

    currentErrorMsg: {
      get: function () {

        let ret = [];
        //dynamic Event
        let secondNow = moment().unix();
        let setupBefore = this.loopRaidBossData.TimeStart - this.loopRaidBossData.SetupBefore;
        if (secondNow > setupBefore) {
          ret.push(`Thời gian bắt đầu không kịp`);
        }

        if (this.loopRaidBossData.CurrentIndexConfig >= this.loopRaidBossData.MaxIndexConfig) {
          ret.push(`Index loop > index max`);
        }

        //leaderboard
        if (this.loopRaidBossData.RewardData.length < 4) {
          ret.push(`Reward data không đủ 4 file`);
        }

        if (this.loopRaidBossData.GrandBossData.length === 0) {
          ret.push(`User Segment không có data`);
        }

        //boss information
        if (this.loopRaidBossData.ConfigRaidBossData.length === 0) {
          ret.push(`Config raidboss không có data`);
        }

        if (this.littleBossData.length === 0) {
          ret.push(`Không general được little boss data`);
        }

        return ret;
      }
    },
  },
  created() {
    this.autoCountDown();
  },
  // watch: {
  //   loopRaidBossData(val){
  //     console.log(`watch TimeStart = ${val.TimeStart}`);
  //     this.countDownNextSetUp = val.TimeStart - moment().unix();
  //   },
  // }
};
</script>

<style scoped>
.red-text {
  color: red;
}
.generate-boss-list-button {
  margin-left: 252px;
  margin-bottom: 20px;
}
.space-to-bottom {
  margin-bottom: 20px;
}
</style>
